import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import LatestLeaks from './components/LatestLeaks';
import AboutIntro from './components/AboutIntro';
import CTASection from './components/CTASection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '黑料吃瓜网',
  url: 'https://www.heiliaochigua.com',
  description: '每日更新热门黑料、网红塌房爆料与不打烊吃瓜资源。覆盖91吃瓜、17吃瓜及在线观看内容，一站直达最新大瓜现场。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.heiliaochigua.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webpageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '黑料吃瓜网 - 首页',
  url: 'https://www.heiliaochigua.com',
  description: '黑料吃瓜网官网入口，每日更新热门黑料、网红塌房爆料与不打烊吃瓜资源。',
  isPartOf: {
    '@type': 'WebSite',
    name: '黑料吃瓜网',
    url: 'https://www.heiliaochigua.com',
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>

      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <LatestLeaks />
        <AboutIntro />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}